import FormatArrowCircleUpOutlinedIcon from "@mui/icons-material/ArrowCircleUpOutlined";
import { SvgIconProps, useTheme } from "@mui/material";

export const ArrowCircleUpOutlinedIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <FormatArrowCircleUpOutlinedIcon
      {...props}
      style={{ color: theme.palette.brandedTypography.textColor }}
    />
  );
};

export default ArrowCircleUpOutlinedIcon;
